import { store } from '../../../../resources/frontend/js/store/index';

export const addressController = new AbortController();

/**
 * Fetch the address using the address auto complete API
 * @param {string} search
 * @param {string} apiToken
 * @param {string} bias
 * @return {Object}
 */
export const addressFetch = async (search, apiToken, bias = '') => {
    const pageStore = store.state.page;
    const url = `/api/address-auto-complete?search=${search}&countryCode=${pageStore.countryCode}&language=${pageStore.language}&sessionToken=${apiToken}&bias=${bias}`;

    return await fetch(url, {
        signal: addressController.signal,
    })
        .then(response => {
            if (!response.ok) {
                throw new Error(`Response status: ${response.status}`);
            }

            return response;
        })
        .then(data => data.json())
        .catch(error => {
            console.error(error);
        });
};

/**
 * Fetch the place using the Google Places API
 * @param {string} placeId
 * @param {string} apiToken
 * @return {Object}
 */
export const googlePlacesFetch = async (placeId, apiToken) => {
    const url = `/api/google-places?place_id=${placeId}&sessionToken=${apiToken}`;
    return await fetch(url)
        .then(response => {
            if (!response.ok) {
                throw new Error(`Response status: ${response.status}`);
            }

            return response;
        })
        .then(data => data.json())
        .catch(error => {
            console.error(error);
        });
};

/**
 * Return the location using the IP Geolocation API
 * @return {String}
 */
export const geolocationBias = async () => {
    const result = await fetch('/api/ip-geolocation').then(response => response.json());

    if (!result.latitude || !result.longitude) {
        return '';
    }

    return result.latitude && result.longitude ? `${result.latitude},${result.longitude}` : '';
};

export const saveAddressLocation = address => {
    store.commit('user/setLocationValue', { key: 'zipcode', value: address.postcode });
    store.commit('user/setLocationValue', { key: 'latitude', value: address.latitude });
    store.commit('user/setLocationValue', { key: 'longitude', value: address.longitude });
};
